<style>
.edi-mobilecheck {
	height: 100%;
	background-color: #eee;
}
.edi-mobilecheck .fieldset-1 {
	margin-top: 4em !important;
}
.edi-mobilecheck .mobile {
	text-align: center;
	line-height: 2.5em;
}
.edi-mobilecheck .mobile b {
	font-weight: normal;
	font-size: 1.5em;
}
.ui-content .ui-listview-inset {
	margin: 1em 0;
	-webkit-border-radius: .3125em;
	border-radius: .3125em;
}
.ui-btn {
	cursor: pointer;
	padding: .3em .8em;
	margin-right: .3em;
}
</style>

<template>
	<form class="ui-content edi-mobilecheck" @submit.prevent="onMobileSubmit">
		<p class="mobile fieldset-1">
			请先完成验证，已发送验证码短信到<br/>
			<b>186*****654</b>
		</p>
		<ul class="ui-listview ui-listview-inset">
			<li class="ui-listview-one-item">
				<div class="ui-col-6"><input type="text" placeholder="验证码" v-model="code"/></div
					><div class="ui-col-4 ui-align-right"><mobile-code :type="2" :mobile="telephone"></mobile-code></div>
			</li>
		</ul>
		<fieldset class="ui-controlgroup">
			<input type="submit" value="确定" class="submit" :class="{ 'ui-disable': submitDisable }"/>
		</fieldset>
	</form>
</template>

<script>
import MobileCode from '../components/MobileCode'

export default {
	data () {
		return {
			telephone: this.$route.query.telephone,
			code: ''
		}
	},
	computed: {
		submitDisable () {
			return !this.code
		}
	},
	components: {
		'mobile-code': MobileCode
	},
	created () {
		this.$http.post('/cldEdi/business/vCode/get', {type: '2', data: this.telephone}).then((response) => {
			window.console.log(response.body)
		})
	},
	methods: {
		onMobileSubmit () {
			var redirect = this.$route.query.redirect
			if (this.submitDisable || !redirect) return
			this.$router.push(redirect)
		}
	}
}
</script>



// WEBPACK FOOTER //
// MobileCheck.vue?06e47727